import React, { Fragment, PureComponent } from "react";
import { withRouter } from "react-router-dom";
import { shopContext } from "../../contexts/aniplus";
// import axios from "axios";
//import socketio from 'socket.io-client';
//import $ from 'jquery';
//import socket from 'socket.io-client/lib/socket';

//const socket = socketio.connect('https://socket.aniplustv.com:4100')

class CardItem extends PureComponent {
  _selectImg = () => {
    const { cardIdx, selectImg } = this.props.childProps;
    selectImg(cardIdx);
  };
  render() {
    const { cardIdx, img, selectCardIdx } = this.props.childProps;
    return (
      <Fragment>
        <li
          className={cardIdx === selectCardIdx ? "active" : ""}
          onClick={this._selectImg}
        >
          <div className="guest_memo">
            {/*<div className="logo"><img src="img/img_logo2.png" alt="애니 타이틀 로고"/></div>
                        <div className="msg"><img src="img/msg.png" alt="메세지"/></div>*/}
            <div className="bg_memo">
              <img src={"/img/guestBook/" + img} alt="메모 배경" />
            </div>
          </div>
        </li>
      </Fragment>
    );
  }
}
export default shopContext(withRouter(CardItem));
